export default __webpack_public_path__ + "static/media/storybook.96046546.png";